import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { id: "screenfull" }
const _hoisted_2 = /*#__PURE__*/_createVNode("svg", {
  class: "icon",
  "aria-hidden": "true",
  "font-size": "40px"
}, [
  /*#__PURE__*/_createVNode("use", { "xlink:href": "#iconshiliangzhinengduixiang1" })
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("svg", {
  class: "icon",
  "aria-hidden": "true",
  "font-size": "40px"
}, [
  /*#__PURE__*/_createVNode("use", { "xlink:href": "#iconshiliangzhinengduixiang1" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.isFullscreen)
      ? (_openBlock(), _createBlock("div", {
          key: 0,
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.click && _ctx.click(...args)))
        }, [
          _hoisted_2
        ]))
      : (_openBlock(), _createBlock("div", {
          key: 1,
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.click && _ctx.click(...args)))
        }, [
          _hoisted_3
        ]))
  ]))
}